import {ILastMinute, IApiLastMinute, ILastMinuteActivity, IApiLastMinuteActivity} from './ILastMinute'
import moment from 'moment'

class Transformer {
    static transform (data: IApiLastMinute): ILastMinute {
        return {
            id: Number(data.id),
            activities: data.attributes.activities.map(
                (apiActivity: IApiLastMinuteActivity): ILastMinuteActivity => {
                    return {
                        id: apiActivity.id,
                        name: apiActivity.name,
                        startsAt: moment(apiActivity.starts_at),
                        endsAt: moment(apiActivity.ends_at),
                        persons: apiActivity.persons,
                        color: apiActivity.color,
                    }
                }
            ),
            isBooked: data.attributes.is_booked,
            hasOverlap: data.attributes.has_overlap,
            isDeleted: false,
            appointment: data.attributes.appointment
        }
    }
}

export default Transformer
